import EAPaginatedTable from "../../EAPaginatedTable";
import {calculateMessstelleLink} from "../../../initialObjects/MessstellenObjects";
import EAButtonBar from "../../EAButtonBar";
import EADownloadButton from "../../EADownloadButton";
import {
    containsSelectAll,
    createCalculatedColumn,
    createColumn,
    createComponentColumn,
    createPaginatedSelectRowComponentColumn
} from "../../../utils/ColumnUtils";
import {
    postMessstellenExportAllEndpointConfiguration,
    postMessstellenExportEndpointConfiguration
} from "../../../services/Messstellenservice";
import React from "react";
import EATableActionButton from "../../tableComponents/EATableActionButton";
import {Link} from "react-router-dom";
import {formatDate} from "../../../utils/DateUtils";
import {parseISO} from "date-fns";
import {userHasAnyRole} from "../../../utils/SecurityUtils";
import {BEAUFTRAGTER, BETREIBER, FACHADMIN, SYSTEMADMIN, ZUST_SBA, ZUST_SBB, ZUST_SBD, ZUST_SBS} from "../../../consts/funktionaleRollen";

export default function MessstelleArbeitsListeTable({
                             id,
                             loading,
                             data,
                             history,
                             selected,
                             setSelected,
                             storedFilter,
                             setStoredFilter,
                             sharedFilter,
                             createQuery
                         }) {
    const anlageColumns = [
        createPaginatedSelectRowComponentColumn("messstelleArbeitsliste", "id", selected, setSelected),
        createComponentColumn(
            "actions",
            (row, index) => {
                return (
                    <div className="eatabwrapper">
                        {editAllowed() && (
                            <EATableActionButton id={"abs-" + index} iconName="ico-edit">
                                <Link to={calculateMessstelleLink(row, "s")}/>
                            </EATableActionButton>
                        )}
                        <EATableActionButton id={"abl-" + index} iconName="ico-view">
                            <Link to={calculateMessstelleLink(row)}/>
                        </EATableActionButton>
                    </div>
                );
            },
            "",
            null,
            {padding: 0, width: "50px", minWidth: "50px", maxWidth: "50px"}
        ),
        createColumn("messstellenId", "Messstellen-Nr."),
        createColumn("bezeichnung", "Messstelle"),
        createColumn("messstellentyp.value", "Messstellentyp"),
        createColumn("abwasseranlage.bezeichnung", "Abwasseranlage"),
        createColumn("abwasseranlage.betrieb.value", "Betrieb"),
        createColumn("messstellenstatus.value", "Status"),
    ];

    function editAllowed() {
        return userHasAnyRole([SYSTEMADMIN, FACHADMIN, BETREIBER, BEAUFTRAGTER, ZUST_SBD, ZUST_SBB, ZUST_SBS, ZUST_SBA]);
    }

    if ((sharedFilter.gueltigVon || sharedFilter.gueltigBis) && !sharedFilter.personalisiert) {
        anlageColumns.push(
            createCalculatedColumn(
                "auditInfo.gueltigAb",
                (row) => (row?.auditInfo?.gueltigAb ? formatDate(parseISO(row.auditInfo.gueltigAb)) : null),
                "Gültig von"
            )
        );
        anlageColumns.push(
            createCalculatedColumn(
                "auditInfo.gueltigBis",
                (row) => (row?.auditInfo?.gueltigBis ? formatDate(parseISO(row.auditInfo.gueltigBis)) : null),
                "Gültig bis"
            )
        );
    }

    return (
        <>
            <EAPaginatedTable
                id={id}
                loading={loading}
                columns={anlageColumns}
                data={data}
                onDoubleClick={(row) => {
                    history.push(calculateMessstelleLink(row));
                }}
                onAltDoubleClick={(row) => {
                    if (editAllowed()) {
                        history.push(calculateMessstelleLink(row, "s"));
                    }
                }}
                pageInfo={storedFilter.pageInfo}
                setPageInfo={(pageInfo) => {
                    setStoredFilter({...storedFilter, pageInfo});
                }}
            />
            <EAButtonBar style={{marginTop: "var(--buttonBar-spacing-top)"}}>
                <EADownloadButton
                    id={"exportArbeitsliste"}
                    loading={loading}
                    label={"Excel-Export"}
                    disabled={!selected || selected.length === 0}
                    config={containsSelectAll(selected) ?
                        postMessstellenExportAllEndpointConfiguration(createQuery({...storedFilter, ...sharedFilter}))
                        : postMessstellenExportEndpointConfiguration(selected)}
                    style={{marginRight: "auto"}}
                />
            </EAButtonBar>
        </>
    );
}
